import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useDynamicSplitButtonCatchupLastViewedTimeQuery, {
	type useDynamicSplitButtonCatchupLastViewedTimeQuery$data,
	type useDynamicSplitButtonCatchupLastViewedTimeQuery$variables,
} from './hooks/__generated__/useDynamicSplitButtonCatchupLastViewedTimeQuery.graphql.ts';

export function preloadAIFloatingContextMenu(
	contentId: string,
	isBlog: boolean,
): Promise<{
	data: useDynamicSplitButtonCatchupLastViewedTimeQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	const contentType = isBlog ? 'BLOGPOST' : 'PAGE';
	return query<
		useDynamicSplitButtonCatchupLastViewedTimeQuery$data,
		useDynamicSplitButtonCatchupLastViewedTimeQuery$variables
	>({
		query: useDynamicSplitButtonCatchupLastViewedTimeQuery,
		variables: {
			contentId,
			contentType,
		},
	});
}
